import { Heading } from '@wix/design-system'
import React, { ComponentProps, FC, ReactNode } from 'react'

import { PageLogger } from '../../../bi/mfi'
import { CommonTemplateLayout } from './CommonTemplateLayout'

export type Props = {
  isPageLoading?: boolean
  pageLogger: PageLogger

  subTitleAbove?: string
  title?: ReactNode
  titleSize?: ComponentProps<typeof Heading>['size']
  subTitleBelow?: string
  backButton?: string
  skipButton?: string
  skipButtonClassName?: string
  onSkipClick?: () => void

  dataHook?: string
  sidePanel?: ReactNode
  logo?: ReactNode
  bottomNote?: ReactNode
  className?: string
  children?: ReactNode
}

export const CommonTemplate: FC<Props> = props => {
  const {
    children,
    subTitleAbove,
    title,
    subTitleBelow,
    skipButton,
    skipButtonClassName,
    onSkipClick,
    dataHook,
    sidePanel,
    logo,
    bottomNote,
    className,
    titleSize,
  } = props

  return (
    <CommonTemplateLayout
      dataHook={dataHook}
      subTitleAbove={subTitleAbove}
      title={title}
      titleSize={titleSize}
      subTitleBelow={subTitleBelow}
      skipButton={skipButton}
      skipButtonClassName={skipButtonClassName}
      onSkipClick={onSkipClick}
      sidePanel={sidePanel}
      className={className}
      logo={logo}
      bottomNote={bottomNote}
    >
      {children}
    </CommonTemplateLayout>
  )
}
